import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import classnames from 'classnames/bind';
import Button from '../../elementals/button';
import Icon from '../../elementals/icon';
import MaskedInputField from '../maskedInputField';
import NumberMask from '../../../utils/numberMask';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const BaseNumberInputField = props => {
    const { maskOptions, showIncrementButtons, incrementBy = 1, onChange, value, buttons, } = props;
    const numberMask = new NumberMask(maskOptions);
    const increment = (up) => {
        const asNumber = value ? `${value}`?.replaceAll(',', '') : '0';
        const currentValue = parseFloat(asNumber);
        const newValue = up
            ? currentValue + incrementBy
            : currentValue - incrementBy;
        if (newValue < 0 && !maskOptions?.allowNegative)
            return;
        const normalizedValue = normalizeOnChange(`${newValue}`);
        if (onChange) {
            const syntheticEvent = {
                target: {
                    value: normalizedValue,
                },
            };
            const meta = { value: normalizedValue };
            onChange(syntheticEvent, meta);
        }
    };
    const normalizeOnChange = (s) => {
        return numberMask.normalize(s, false);
    };
    const normalizeOnBlur = (s) => {
        return numberMask.normalize(s, true);
    };
    return (_jsxs(MaskedInputField, { inputMode: 'numeric', mask: numberMask.mask, normalizeOnChange: normalizeOnChange, normalizeOnBlur: normalizeOnBlur, ..._.omit(props, ['maskOptions', 'showIncrementButtons']), children: [_jsx("input", { className: cx({ 'input-with-buttons-on-right': showIncrementButtons }) }), showIncrementButtons && (_jsx(Button, { elmId: `${buttons?.decrement?.elmId ?? 'decrement'}_button`, collapse: true, className: cx('minus-button'), onClick: () => increment(false), children: _jsx(Icon, { name: 'minus', iconStyle: 'light' }) })), showIncrementButtons && (_jsx(Button, { elmId: `${buttons?.increment?.elmId ?? 'increment'}_button`, collapse: true, className: cx('plus-button'), onClick: () => increment(true), children: _jsx(Icon, { name: 'plus', iconStyle: 'light' }) }))] }));
};
BaseNumberInputField.defaultProps = {
    compact: false,
};
export default BaseNumberInputField;
//# sourceMappingURL=index.js.map